import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_CERTIFICATE_COASTAL_SEGMENTS",
    applicationRights: Rights,
    title: 'Losens omr&aring;der',
    text: 'Losens omr&aring;der',
    icon: 'squares-four',
    showOnDashboardByDefault: false,
    url: "/pilot-certificate-coastal-segments",
    mobileThreshold: 1024,
    sequenceNo: 17000,
    routes: Routes
})
